var React = require('react');

function ArrowNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.8995 7.41384L5.89968 7.41403L7.3139 5.99981L2.36415 1.05007C1.97362 0.659541 1.34046 0.659541 0.949935 1.05007C0.559411 1.44059 0.55941 2.07375 0.949935 2.46428L4.48528 5.99963L0.949563 9.53535C0.559038 9.92587 0.559038 10.559 0.949563 10.9496C1.34009 11.3401 1.97325 11.3401 2.36378 10.9496L5.8995 7.41384Z","fill":"#003B1B"}));
}

ArrowNext.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = ArrowNext;

ArrowNext.default = ArrowNext;
